import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect, useSelector } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Paper, Tooltip, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import DoBarChart from "../DoBarChart";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
// import { setModuleTabIndex } from '../../../../store/Actions';
import SwitchComponent from "../GraphViewPOOS/SwitchComponent";
import GraphWithMinandMax from "../GraphWithMinandMax";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
 
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}
 
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
 
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
 
const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
  dropDownLabel: {
    marginLeft: "1vw",
  },
}));
 
const GraphViewFF = ({
  tabIndex,
  Module,
  Network,
  DC,
  graphViewTabList,
  date,
  applyFilter,
  role,
  Temperature,
  fromState,
  toState,
  fromZip,
  toZip,
  lane,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const [typeValue, setTypeValue] = useState("Delivery");
  const [networkSelected, setNetworkSelected] = useState("Ambient");
  const [temperatureSelected, setTemperatureSelected] = useState("Ambient");
  const [countValue, setCountValue] = useState("5");
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue
  )[0].name;
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [avgandMin, setAvgandMin] = useState(false);
 
  const getTemperatureOptions = (network) => {
    switch (network) {
      case "Ambient":
        return ["Ambient", "Temp Controlled"];
      case "Chilled":
        return ["Ambient", "Chilled", "Temp Controlled"];
      case "Frozen":
        return ["Frozen"];
      case "NPW":
        return ["NPW"];
      default:
        return [];
    }
  };
 
  const getGraphData = (params) => {
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          setGraphData(data?.data?.data ? data?.data?.data : data?.data);
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => setLoading(false));
  };
 
  let typeFormate =
    graphViewTabList[tabValue]?.value === "Over Capacity"
      ? avgandMin
        ? "Over Capacity Avg and Min"
        : "Over Capacity"
      : avgandMin
      ? "Under Capacity Avg and Min"
      : graphViewTabList[tabValue]?.value;
  const memoizedParams = useMemo(
    () => ({
      section: Module,
      type: typeFormate,
      name: temperatureSelected,
      arrangements: topOrBottomValue,
      value: countValue,
      X_Axis: temperatureSelected,
      Level: role,
      filter: {
        Network:
          Module === "FF"
            ? networkSelected
              ? [networkSelected]
              : Network
            : Network,
        temperature:
          temperatureSelected === "Temp Controlled"
            ? ["TEMPCONTROLLED", "FROZEN"]
            : [temperatureSelected],
        Source_State: fromState,
        Destination_State: toState,
        Source_3zip: fromZip,
        Destination_3zip: toZip,
        lane: lane,
        deliveryCondition: [typeValue],
        startDate: date?.[0],
        endDate: date?.[1],
      },
    }),
    [
      Module,
      tabValue,
      temperatureSelected,
      topOrBottomValue,
      typeValue,
      countValue,
      role,
      DC,
      Network,
      Temperature,
      fromState,
      toState,
      fromZip,
      toZip,
      lane,
      date,
      networkSelected,
      avgandMin,
    ]
  );
 
  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);
 
  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    setTemperatureSelected("Ambient");
    setTypeValue("Delivery");
    setTopOrBottomValue("Top");
    setCountValue("5");
  };
 
  const handleTopBottomChange = (event) => {
    setTopOrBottomValue(event.target.value);
  };
 
  const handleTypeChange = (event) => {
    setTypeValue(event.target.value);
  };
  const handleNetworkChange = (event) => {
    const selectedNetwork = event.target.value;
    setNetworkSelected(selectedNetwork);
    const newTemperatureOptions = getTemperatureOptions(selectedNetwork);
    setTemperatureSelected(
      newTemperatureOptions.length > 0 ? newTemperatureOptions[0] : ""
    );
  };
 
  const handleCountChange = (event) => {
    setCountValue(event.target.value);
  };
 
  const renderChart = () => {
    const chartProps = {
      graphData,
      showAnnotation: true,
      activeTab,
    };
    if (Module === "FF") {
      if (avgandMin) {
        if (activeTab === "Over Capacity" || activeTab === "Under Capacity") {
          return (
            <GraphWithMinandMax graphData={graphData} activeTab={activeTab} />
          );
        } else {
          return (
            <DoBarChart
              {...chartProps}
              activeTab={activeTab}
              yAxisTitle="Est spent for awards $"
            />
          );
        }
      } else {
        if (activeTab === "Over Capacity" || activeTab === "Under Capacity") {
          return (
            <DPGroupedBarLineChart
              graphData={graphData}
              activeTab={activeTab}
            />
          );
        } else {
          return (
            <DoBarChart
              {...chartProps}
              activeTab={activeTab}
              yAxisTitle="Est spent for awards $"
            />
          );
        }
      }
    }
  };
 
  const getTooltipTitle = (item) => {
    switch (item) {
      case "Under Capacity":
        return `From freight forecast. Sum of the awards shortage by lanes with filter for weeks, network, 3zips, dates and states`;
 
      case "Over Capacity":
        return `From freight forecast. Sum of the excess awards by lanes with filter for weeks, network, 3zips, dates and states`;
 
      case "Transport Spend by Lane":
        return `From latest Freight Forecast output and chain analytics. Total cost of awards based on the freight rates`;
      // Add more cases as needed for each KPI
      default:
        return "This is additional information about the KPI";
    }
  };
 
  const handleAvgandMin = (event) => {
    setAvgandMin(event.target.checked);
  };
  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
                        <div className={classes.appBar}> */}
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* </div>
                    </div> */}
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack
                direction="row"
                alignItems="center"
                sx={{ padding: "22px 8px" }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Select
                    value={topOrBottomValue}
                    onChange={handleTopBottomChange}
                    className={classes.select}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={classes.select}
                  >
                    <MenuItem value="Top">Top</MenuItem>
                    <MenuItem value={"Bottom"}>Bottom</MenuItem>
                  </Select>
                  <Select
                    value={countValue}
                    onChange={handleCountChange}
                    className={classes.select}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={classes.select}
                  >
                    {countList.map((item, _index) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </Stack>
 
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "30px",
                }}
              >
                <label style={{ color: "#0000008a", alignSelf: "flex-end" }}>
                  Summarized{" "}
                </label>
                <div>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#aaaaaaff",
                      mb: "4px",
                      marginLeft: "18px",
                    }}
                  >
                    Network
                  </Typography>
                  <Select
                    value={networkSelected}
                    onChange={handleNetworkChange}
                    className={classes.select}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={classes.select}
                  >
                    <MenuItem value="Ambient">Ambient</MenuItem>
                    <MenuItem value="Frozen">Frozen</MenuItem>
                    <MenuItem value="Chilled">Chilled</MenuItem>
                    <MenuItem value="NPW">NPW</MenuItem>
                  </Select>
                </div>
                <div>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#aaaaaaff",
                      mb: "4px",
                      marginLeft: "18px",
                    }}
                  >
                    Temperature
                  </Typography>
                  <Select
                    value={temperatureSelected}
                    onChange={(e) => setTemperatureSelected(e.target.value)}
                    displayEmpty
                    className={classes.select}
                    inputProps={{ "aria-label": "Without label" }}
                    disabled={!networkSelected} // Disable if no network selected
                  >
                    {getTemperatureOptions(networkSelected).map((temp) => (
                      <MenuItem key={temp} value={temp}>
                        {temp}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#aaaaaaff",
                      mb: "4px",
                      marginLeft: "18px",
                    }}
                  >
                    Type
                  </Typography>
                  <Select
                    value={typeValue}
                    onChange={handleTypeChange}
                    className={classes.select}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={classes.select}
                  >
                    <MenuItem value="Delivery">Delivery</MenuItem>
                    <MenuItem value={"Supply"}>Supply</MenuItem>
                  </Select>
                </div>
                <Tooltip
                  title={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: getTooltipTitle(activeTab),
                      }}
                    />
                  }
                  placement="top"
                >
                  <InfoOutlinedIcon
                    fontSize="small"
                    style={{
                      color: "blue",
                      marginLeft: "5px",
                      cursor: "pointer",
                      marginTop:"22px"
                    }}
                  />
                </Tooltip>
              </div>
              <div style={{ marginLeft: "15px",marginTop:"10px" }}>
                {" "}
                <SwitchComponent
                  value={avgandMin}
                  handleChange={handleAvgandMin}
                  labelValue={"Total"}
                />
              </div>
 
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};
 
GraphViewFF.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};
 
const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
  Temperature: state.filter.Temperature,
  // Products: state.filter.Products,
  fromState: state.filter.fromState,
  toState: state.filter.toState,
  fromZip: state.filter.fromZip,
  toZip: state.filter.toZip,
  lane: state.filter.lane,
});
 
const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(GraphViewFF);